module.exports = __webpack_public_path__ + "files/b22a8616fee34b00a3e3c5f5460e1821.png";